import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';
import BASEAPI from '@/util/BASEAPI';


@Component({
})
export default class SAItemCard extends Mixins(BASEComponentVue) {

    @Prop({
        type: String,
        default: ""
    })
    image!: "";

    @Prop({
        type: String,
        default: ""
    })
    title!: "";

    @Prop({
        type: String,
        default: ""
    })
    description!: "";

    @Prop({
        type: String,
        default: ""
    })
    size!: "";

    @Prop({
        type: Boolean,
        default: false
    })
    off!: boolean;


    @Prop({
        type: Number,
        default: null
    })
    count!: number | null;

    @Emit("click")
    public click() {
    }

    public onButtonClick() {
        this.$emit("click");
    }
}
